import React from 'react'
import hasAccess from 'components/Helpers/hasAccess'

const PermissionButton = ({ user, permission, disabledTitle, onClick, children, ...rest }) => {
  const allowed = !permission || hasAccess(user, permission)

  return (
    <button
      {...rest}
      onClick={allowed ? onClick : undefined}
      disabled={rest.disabled || !allowed}
      aria-disabled={!allowed || undefined}
      title={allowed ? rest.title : (disabledTitle || "You don't have permission to do this")}
    >
      {children}
    </button>
  )
}

export default PermissionButton
